module.exports = __webpack_public_path__ + "static/media/C05.96ceb38d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/customs/C05.png
// module id = 205
// module chunks = 0